export default {"src":"/_next/static/media/blue-blob-mask-2.145e2d77.svg","height":107,"width":129,"blurWidth":0,"blurHeight":0};